<template>
  <div class="room-device-setting-modal-component" @click="closeModal">
    <div class="room-device-setting-modal" @click.stop>
      <CamstudyPreview />
    </div>
  </div>
</template>

<script>
import CamstudyPreview from "@/components/Room/DeviceSetting/coordi/CamstudyPreview.vue";

export default {
  name: 'CamstudyDeviceSettingModal',
  components: {
    CamstudyPreview
  },
  methods: {
    closeModal(){
      this.$modal('CamstudyDeviceSettingModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.room-device-setting-modal-component {
  display: grid;
  justify-content: center;
  align-items: center;
  position: absolute;
  @media(orientation: landscape) {
    z-index: 102;
  }
  @media(orientation: portrait) {
    z-index: 102;
  }
  &::-webkit-scrollbar {
    display: none;
  }
}
.room-device-setting-modal {
  width: 360px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-left: 0.5px solid rgba(255, 255, 255, 0.20);
  background: #1A1A1A;
  &::-webkit-scrollbar{
    display: none;
  }
}

// Mobile
[grm-device-mobile] {
  .room-device-setting-modal-component {
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow-y: auto;
  }
  .room-device-setting-modal {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
html:not([grm-device-mobile]) {
  .room-device-setting-modal-component {
    top: 0;
    right: 0;
    bottom: 80px;
    left: 0;
    .room-device-setting-modal {
      bottom: -80px;
    }
  }
}
</style>